var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _AccordionCustom_instances, disableOnMobile_get, disableOnDesktop_get, closeWithEscape_get, _controller, _handleContentClick, _handleMediaQueryChange, setDefaultOpenState_fn, handleKeyDown_fn;
import { mediaQueryLarge, isMobileBreakpoint } from "@theme/utilities";
class AccordionCustom extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _AccordionCustom_instances);
    __privateAdd(this, _controller, new AbortController());
    /**
     * Handles the click event.
     * @param {Event} event - The event.
     */
    __publicField(this, "handleClick", (event) => {
      const isMobile = isMobileBreakpoint();
      const isDesktop = !isMobile;
      if (isMobile && __privateGet(this, _AccordionCustom_instances, disableOnMobile_get) || isDesktop && __privateGet(this, _AccordionCustom_instances, disableOnDesktop_get)) {
        event.preventDefault();
        return;
      }
    });
    /**
     * Closes the accordion when a click lands inside an element marked with
     * `[data-accordion-close]` (or one of its descendants). Used by markup that
     * provides an explicit close-target region inside the content area.
     *
     * @param {MouseEvent} event - The click event.
     */
    __privateAdd(this, _handleContentClick, (event) => {
      if (!this.details.open) return;
      if (!/** @type {Element} */
      event.target.closest("[data-accordion-close]")) return;
      this.summary.focus({ preventScroll: true });
      this.details.open = false;
    });
    /**
     * Handles the media query change event.
     */
    __privateAdd(this, _handleMediaQueryChange, () => {
      __privateMethod(this, _AccordionCustom_instances, setDefaultOpenState_fn).call(this);
    });
  }
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector("details");
    if (!(details instanceof HTMLDetailsElement)) throw new Error("Details element not found");
    return details;
  }
  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector("summary");
    if (!(summary instanceof HTMLElement)) throw new Error("Summary element not found");
    return summary;
  }
  connectedCallback() {
    const { signal } = __privateGet(this, _controller);
    __privateMethod(this, _AccordionCustom_instances, setDefaultOpenState_fn).call(this);
    this.addEventListener("keydown", __privateMethod(this, _AccordionCustom_instances, handleKeyDown_fn), { signal });
    this.summary.addEventListener("click", this.handleClick, { signal });
    this.details.addEventListener("click", __privateGet(this, _handleContentClick), { signal });
    mediaQueryLarge.addEventListener("change", __privateGet(this, _handleMediaQueryChange), { signal });
  }
  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    __privateGet(this, _controller).abort();
  }
}
_AccordionCustom_instances = new WeakSet();
disableOnMobile_get = function() {
  return this.dataset.disableOnMobile === "true";
};
disableOnDesktop_get = function() {
  return this.dataset.disableOnDesktop === "true";
};
closeWithEscape_get = function() {
  return this.dataset.closeWithEscape === "true";
};
_controller = new WeakMap();
_handleContentClick = new WeakMap();
_handleMediaQueryChange = new WeakMap();
/**
 * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
 */
setDefaultOpenState_fn = function() {
  const isMobile = isMobileBreakpoint();
  this.details.open = isMobile && this.hasAttribute("open-by-default-on-mobile") || !isMobile && this.hasAttribute("open-by-default-on-desktop");
};
/**
 * Handles keydown events for the accordion
 *
 * @param {KeyboardEvent} event - The keyboard event.
 */
handleKeyDown_fn = function(event) {
  if (event.key === "Escape" && __privateGet(this, _AccordionCustom_instances, closeWithEscape_get)) {
    event.preventDefault();
    this.summary.focus();
    this.details.open = false;
  }
};
if (!customElements.get("accordion-custom")) {
  customElements.define("accordion-custom", AccordionCustom);
}
